import { Alert, Stack } from "@mui/material";
import {
  Trip,
  TripShipmentLocation,
  ViolationCause,
} from "../../../graphql/generated";
import enumLabel from "../../../utils/labels/enumLabel";
import { formatDuration } from "../../../utils/labels/formatDateTime";

const TripViolations = ({
  trip,
  shiftEndWarningTestId,
}: {
  trip: {
    shipmentLocations: Pick<TripShipmentLocation, "name" | "_id">[];
    violations?: Trip["violations"];
  };
  shiftEndWarningTestId?: string;
}) => {
  return (
    <Stack>
      {trip?.violations?.map((violation, index) => {
        const location = trip.shipmentLocations.find(
          (location) => location._id === violation.locationId
        );
        
        const displayMessage = violation.message || 
          `${enumLabel(violation.cause)}${violation.duration ? ` of ${formatDuration(violation.duration)}` : ''}${location ? ` at ${location.name}` : ''}`;
        
        return (
          <Alert
            data-testid={
              violation.cause === ViolationCause.EndDelay
                ? shiftEndWarningTestId
                : undefined
            }
            severity="warning"
            key={index}
          >
            {displayMessage}
          </Alert>
        );
      })}
    </Stack>
  );
};

export default TripViolations;
